/**
 * Contact email list helpers for customer/admin profile UIs.
 */

export const CONTACT_EMAIL_FIELDS = [
  "primary_biz_contact_emails",
  "primary_it_contact_emails",
  "primary_clinical_contact_emails",
  "primary_laboratory_contact_emails",
  "digital_imaging_technician_contact_emails",
];

export const CONTACT_EMAIL_LABELS = {
  primary_biz_contact_emails: "Business owner",
  primary_it_contact_emails: "Primary IT contact",
  primary_clinical_contact_emails: "Primary clinical contact",
  primary_laboratory_contact_emails: "Primary laboratory contact",
  digital_imaging_technician_contact_emails: "Digital imaging technician",
};

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function normalizeEmailList(raw) {
  const items = Array.isArray(raw) ? raw : raw == null || raw === "" ? [] : [raw];
  const out = [];
  const seen = new Set();
  for (const item of items) {
    if (item == null) continue;
    const email = String(item).trim().toLowerCase();
    if (!email || seen.has(email)) continue;
    seen.add(email);
    out.push(email);
  }
  return out;
}

export function withNormalizedContactEmails(profile) {
  const next = { ...(profile || {}) };
  for (const field of CONTACT_EMAIL_FIELDS) {
    const legacy =
      field === "primary_biz_contact_emails"
        ? next.primary_biz_contact
        : field === "primary_it_contact_emails"
          ? next.primary_it_contact
          : field === "primary_clinical_contact_emails"
            ? next.primary_clinical_contact
            : undefined;
    next[field] = normalizeEmailList(
      next[field] != null ? next[field] : legacy
    );
  }
  return next;
}

export function isValidEmail(value) {
  const email = String(value || "").trim().toLowerCase();
  return EMAIL_RE.test(email) && !email.includes("..");
}

export function contactEmailsPayload(profile) {
  const payload = {};
  for (const field of CONTACT_EMAIL_FIELDS) {
    payload[field] = normalizeEmailList(profile?.[field]);
  }
  return payload;
}
